<div class="component-container" *ngIf="editable && isInterp==false">
  <div *ngIf="!editing;else edit" (click)="onTextClicked()" class="text-container" [class.majorOutlier]="major" [class.minorOutlier]="minor" title="Click to edit">
    <span class="text-container__text">{{data}}</span>
    <i class="material-icons text-container__edit" *ngIf="LuStatusID!=7">edit</i>
  </div>
  <ng-template #edit>
    <div *ngIf="disable_decimal" class="input-container" [class.input-container--right]="alignRight">

      <!-- <input *ngIf="disable_decimal" (onkeypress)="GetOnlyDecimal($event)" class="input-container__input" #dataInput type="number" [value]="data" (blur)="onInputBlur(dataInput.value)" (keyup.enter)="onSaveClicked(dataInput.value)" (keyup.esc)="onCancelClicked()" focusOnShow /> -->
      <input onkeypress="return event.charCode >= 48 && event.charCode <= 57" class="input-container__input" #dataInput type="number" [value]="data" (blur)="onInputBlur(dataInput.value)" (keyup.enter)="onSaveClicked(dataInput.value)" (keyup.esc)="onCancelClicked()" focusOnShow />

      <!-- <input *ngIf="!disable_decimal" class="input-container__input" #dataInput type="number" [value]="data" (blur)="onInputBlur(dataInput.value)" (keyup.enter)="onSaveClicked(dataInput.value)" (keyup.esc)="onCancelClicked()" focusOnShow /> -->
      <div class="input-container__buttons">
        <div class="save-button" title="Save Changes" (click)="onSaveClicked(dataInput.value)">
          <i class="material-icons save-button__icon">check</i>
        </div>
        <div class="cancel-button" title="Cancel" (click)="onCancelClicked()">
          <i class="material-icons cancel-button__icon">close</i>
        </div>
      </div>
    </div>

    <div  *ngIf="!disable_decimal" class="input-container" [class.input-container--right]="alignRight">

      <!-- <input *ngIf="disable_decimal" (onkeypress)="GetOnlyDecimal($event)" class="input-container__input" #dataInput type="number" [value]="data" (blur)="onInputBlur(dataInput.value)" (keyup.enter)="onSaveClicked(dataInput.value)" (keyup.esc)="onCancelClicked()" focusOnShow /> -->
      <input class="input-container__input" #dataInput type="number" [value]="data" (blur)="onInputBlur(dataInput.value)" (keyup.enter)="onSaveClicked(dataInput.value)" (keyup.esc)="onCancelClicked()" focusOnShow />

      <!-- <input *ngIf="!disable_decimal" class="input-container__input" #dataInput type="number" [value]="data" (blur)="onInputBlur(dataInput.value)" (keyup.enter)="onSaveClicked(dataInput.value)" (keyup.esc)="onCancelClicked()" focusOnShow /> -->
      <div class="input-container__buttons">
        <div class="save-button" title="Save Changes" (click)="onSaveClicked(dataInput.value)">
          <i class="material-icons save-button__icon">check</i>
        </div>
        <div class="cancel-button" title="Cancel" (click)="onCancelClicked()">
          <i class="material-icons cancel-button__icon">close</i>
        </div>
      </div>
    </div>
  </ng-template>
</div>



<div class="component-container" *ngIf="editable && isInterp==true">
  <div *ngIf="!editing;else edit" (click)="onTextClicked()" class="text-container" [class.majorOutlier]="major" [class.minorOutlier]="minor" title="Click to edit">
    <span class="text-container__text">{{data}}</span>
    <i class="material-icons text-container__edit" *ngIf="LuStatusID!=7">edit</i>
  </div>
  <ng-template #edit>
    <div *ngIf="disable_decimal" class="input-container" [class.input-container--right]="alignRight">

      <!-- <input *ngIf="disable_decimal" (onkeypress)="GetOnlyDecimal($event)" class="input-container__input" #dataInput type="number" [value]="data" (blur)="onInputBlur(dataInput.value)" (keyup.enter)="onSaveClicked(dataInput.value)" (keyup.esc)="onCancelClicked()" focusOnShow /> -->
      <input onkeypress="return event.charCode >= 48 && event.charCode <= 57" class="input-container__input" #dataInput type="number" [value]="data" (blur)="onInputBlur(dataInput.value)" (keyup.enter)="onSaveClicked(dataInput.value)" (keyup.esc)="onCancelClicked()"  (keyup.tab)="onSaveClicked(dataInput.value)" (focusout)="onSaveClicked(dataInput.value)" focusOnShow />

      <!-- <input *ngIf="!disable_decimal" class="input-container__input" #dataInput type="number" [value]="data" (blur)="onInputBlur(dataInput.value)" (keyup.enter)="onSaveClicked(dataInput.value)" (keyup.esc)="onCancelClicked()" focusOnShow /> -->
      <!-- <div class="input-container__buttons">
        <div class="save-button" title="Save Changes" (click)="onSaveClicked(dataInput.value)">
          <i class="material-icons save-button__icon">check</i>
        </div>
        <div class="cancel-button" title="Cancel" (click)="onCancelClicked()">
          <i class="material-icons cancel-button__icon">close</i>
        </div>
      </div> -->
    </div>

    <div  *ngIf="!disable_decimal" class="input-container" [class.input-container--right]="alignRight">

      <!-- <input *ngIf="disable_decimal" (onkeypress)="GetOnlyDecimal($event)" class="input-container__input" #dataInput type="number" [value]="data" (blur)="onInputBlur(dataInput.value)" (keyup.enter)="onSaveClicked(dataInput.value)" (keyup.esc)="onCancelClicked()" focusOnShow /> -->
      <input class="input-container__input" #dataInput type="number" [value]="data" (blur)="onInputBlur(dataInput.value)" (keyup.enter)="onSaveClicked(dataInput.value)" (keyup.esc)="onCancelClicked()" (keyup.tab)="onSaveClicked(dataInput.value)" (focusout)="onSaveClicked(dataInput.value)"focusOnShow />

      <!-- <input *ngIf="!disable_decimal" class="input-container__input" #dataInput type="number" [value]="data" (blur)="onInputBlur(dataInput.value)" (keyup.enter)="onSaveClicked(dataInput.value)" (keyup.esc)="onCancelClicked()" focusOnShow /> -->
      <!-- <div class="input-container__buttons">
        <div class="save-button" title="Save Changes" (click)="onSaveClicked(dataInput.value)">
          <i class="material-icons save-button__icon">check</i>
        </div>
        <div class="cancel-button" title="Cancel" (click)="onCancelClicked()">
          <i class="material-icons cancel-button__icon">close</i>
        </div>
      </div> -->
    </div>
  </ng-template>
</div>
<span *ngIf="!editable">
  {{data}}
</span>
